module.exports = __webpack_public_path__ + "img/111028.8ce0180f.png";